import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

/** @module */
class SignupStepIndexRoute extends Route {
  @service('local-storage-fallback')
  storage;

  @service
  session;

  @service
  router;

  /** @inheritDoc */
  model() {
    return {
      user: this.session.currentUser,
    };
  }

  /** @inheritDoc */
  redirect() {
    const user = this.session.currentUser;
    const storage = this.storage;

    // first time in the funnel experience, don't show them the welcome back screen
    if (storage.getItem('creatorSignup')) {
      storage.removeItem('creatorSignup');

      switch (user.signupStep) {
        case 'validate_email':
          this.router.replaceWith(EMBER_ROUTE_NAMES.SIGNUP__STEP__VERIFY_EMAIL);
          return;

        case 'extended_profile':
          this.router.replaceWith(EMBER_ROUTE_NAMES.SIGNUP__STEP__BACKGROUND);
          return;

        case 'work_samples':
          this.router.replaceWith(EMBER_ROUTE_NAMES.SIGNUP__STEP__WORK);
          return;

        case 'done':
          this.router.replaceWith(EMBER_ROUTE_NAMES.SIGNUP__STEP__DONE);
          return;

        default:
          this.router.replaceWith(EMBER_ROUTE_NAMES.SIGNUP__STEP__PROFILE);
          return;
      }
    }

    if (user.signupStep === 'done') {
      this.router.replaceWith(EMBER_ROUTE_NAMES.DASHBOARD);
    }
  }

  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/signup/step/');
  }
}

export default SignupStepIndexRoute;
